module.exports = __webpack_public_path__ + "img/jazz_xxl_natural_ba_list.0f075a92.jpg";